import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { quantStudioTheme, quantStudioDarkTheme } from './theme/themes';
import { useIsDarkMode } from './theme/useIsDarkMode';
import { AppRouter } from './router';
import { ChartThemeProvider } from './components/ChartThemeProvider/ChartThemeProvider';

const App: React.FC = () => {
  const isDark = useIsDarkMode();

  return (
    <ThemeProvider theme={isDark ? quantStudioDarkTheme : quantStudioTheme}>
      <CssBaseline />
      <ChartThemeProvider>
        <AppRouter />
      </ChartThemeProvider>
    </ThemeProvider>
  );
};

export default App;
